import {
	formatter,
	useLanguageResource,
} from "@ruter-as/web-components-and-tools";
import type React from "react";
import { useAuthenticatedAuthContext } from "../auth/Auth.component";
import { formLanguageResource } from "./lang-resource";
import "./ProductPrice.scss";

interface Props {
	price: number | "UNKNOWN";
	gray?: boolean;
}

const ProductPrice: React.FC<Props> = ({ gray, price }) => {
	const lang = useLanguageResource(formLanguageResource);
	const { selectedCompany } = useAuthenticatedAuthContext();

	const formattedPrice =
		price === "UNKNOWN"
			? "Klarte ikke beregne pris"
			: formatter.number.integer(Math.floor(price));
	const formattedDate = formatter.date.toMonthAndYear(new Date());
	const showDisclaimer = selectedCompany.subTypeId === "SUBSCRIPTIONS";

	const cssClassNames = ["components-common-form-productpricefield"];
	if (gray) {
		cssClassNames.push("gray");
	}

	return (
		<div className={cssClassNames.join(" ")} data-test-id="price-field">
			<div className="label">{lang.productName(formattedDate)}</div>
			<div>
				<span className="price" data-test-id="product-price-field">
					{formattedPrice}
				</span>
				<span className="label">kr</span>
			</div>
			{showDisclaimer && (
				<div data-test-id="price-disclaimer" className="label">
					Eventuelle subsidier som arbeidsgiver gir, vil ikke vises her
				</div>
			)}
		</div>
	);
};

export default ProductPrice;
